module.exports = __webpack_public_path__ + "static/media/clark-street-merc.4e443266.jpg";